import { convertUTCToLocal } from '@packages/toolbox/dist/utils/datetime';
import { UserBrief } from 'SharedDir/declarations/user';
import { Chats } from 'SharedDir/declarations/chats';
import Attachment from 'SharedDir/service/file/uploader';

export default class ChatMessage {
  id!: number;

  message!: string;

  attachments: Array<Attachment> = [];

  createdAt!: Date;

  userId!: number;

  user!: UserBrief;

  mentions: Array<any> = [];

  constructor(message: Chats.Message) {
    ({
      id: this.id,
      message: this.message,
      attachments: this.attachments,
      userId: this.userId,
      user: this.user,
    } = message);
    this.createdAt = convertUTCToLocal(message.createdAt);
  }
}
